<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="100px">
					<el-form-item label="所属团队" prop="teamId" v-if="roleId==2">
						<el-select v-model="queryParams.teamId" style="width: 100%;" placeholder="请选择团队">
							<el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="处理状态">
						<el-select v-model="queryParams.status" placeholder="请选择处理状态">
							<el-option label="全部" value=""></el-option>
							<el-option label="未处理" :value="0"></el-option>
							<el-option label="已处理" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd" v-has="'btn_add'">添加</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column prop="orderNo" label="维护号" width="180"></el-table-column>
					<el-table-column prop="title" label="描述"></el-table-column>
					<el-table-column prop="deviceTitle" label="关联设备"></el-table-column>
					<el-table-column prop="level" label="优先级">
						<template slot-scope="scope">
							<div v-if="scope.row.level==1" style="color: #67c23a;">低</div>
							<div v-if="scope.row.level==2" style="color: #e6a23c;">中</div>
							<div v-if="scope.row.level==3" style="color: #f56c6c;">高</div>
						</template>
					</el-table-column>
					<el-table-column prop="description" label="处理描述"></el-table-column>
					<el-table-column prop="status" label="状态">
						<template slot-scope="scope">
							{{scope.row.status | formatStatus}}
						</template>
					</el-table-column>
					<el-table-column prop="operatorName" label="处理人"></el-table-column>
					<el-table-column prop="operateTime" label="处理时间"></el-table-column>
					<el-table-column prop="creatorName" label="创建人"></el-table-column>
					<el-table-column prop="createTime" label="创建时间"></el-table-column>
					<el-table-column fixed="right" label="操作" width="240">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleDetail(scope.row)">查看</el-button>
							<el-button size="mini" type="primary" @click="handleEdit(scope.row)" v-if="scope.row.creatorId==loginUserId">编辑</el-button>
							<el-button size="mini" type="danger" @click="batchUpdateStatus(-1,'删除',scope.row.id)" v-if="scope.row.creatorId==loginUserId && scope.row.status==0">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 添加/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" :before-close="handleClose">
			<el-form :inline="false" :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="120px">
				<el-form-item label="关联设备" prop="deviceId">
					<el-select v-model="addOrUpdateForm.deviceId" ref="deviceSelect" filterable remote reserve-keyword placeholder="请选择设备" :remote-method="queryDeviceList"
						:loading="deviceLoading" @focus="deviceSelectFocus" :clearable="true">
						<el-option v-for="item in deviceList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="描述" prop="title">
					<el-input type="textarea" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.title" placeholder="请输入工单描述"></el-input>
				</el-form-item>
				<el-form-item label="上传照片" prop="images">
					<el-upload :file-list="imageList" action="/api/system/file/upload" list-type="picture-card" :on-success="handleUploadSuccess" :before-upload="beforeUpload"
						:headers="headers" :auto-upload="true">
						<i slot="default" class="el-icon-plus"></i>
						<div slot="file" slot-scope="{file}">
							<el-image style="width: 80px; height: 80px" :src="file.url" fit="fit"></el-image>
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
									<i class="el-icon-zoom-in"></i>
								</span>
								<span class="el-upload-list__item-delete" @click="handleRemove(file)">
									<i class="el-icon-delete"></i>
								</span>
							</span>
						</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="优先级" prop="level">
					<el-radio-group v-model="addOrUpdateForm.level" size="small">
						<el-radio-button :label="3">高</el-radio-button>
						<el-radio-button :label="2">中</el-radio-button>
						<el-radio-button :label="1">低</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="分配人员" prop="operatorId">
					<el-select v-model="addOrUpdateForm.operatorId" ref="operatorSelect" placeholder="请选择分配人员">
						<el-option :key="user.id" :label="user.realName" :value="user.id" v-for="user in userList"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="handleClose()">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog title="工单详情" :visible.sync="dialogDetailVisible" width="600px" :close-on-click-modal="false">
			<el-row>
				<el-descriptions class="margin-top" :column="1" :labelStyle="label_style">
					<el-descriptions-item label="关联设备">
						{{addOrUpdateForm.deviceTitle}}
					</el-descriptions-item>
					<el-descriptions-item label="描述">
						<el-input type="textarea" :disabled="true" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.title"></el-input>
					</el-descriptions-item>
					<el-descriptions-item label="上传照片">
						<span class="el-descriptions-item__content">
							<div >
							<ul class="el-upload-list el-upload-list--picture-card">
								<li tabindex="0" class="el-upload-list__item is-success" v-for="(image,index) in addOrUpdateForm.imageList" :key="index">
									<el-image style="width: 80px; height: 80px" :src="image" fit="fit" :preview-src-list="addOrUpdateForm.imageList"></el-image>
								</li>
							</ul>
							</div>
						</span>
					</el-descriptions-item>
					<el-descriptions-item label="优先级">
						<div v-if="addOrUpdateForm.level==1" style="color: #67c23a;">低</div>
						<div v-if="addOrUpdateForm.level==2" style="color: #e6a23c;">中</div>
						<div v-if="addOrUpdateForm.level==3" style="color: #f56c6c;">高</div>
					</el-descriptions-item>
					<el-descriptions-item label="分配人员">
						{{addOrUpdateForm.operatorName}}
					</el-descriptions-item>
					<el-descriptions-item label="处理描述">
						<el-input type="textarea" :disabled="true" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.description"></el-input>
					</el-descriptions-item>
				</el-descriptions>
			</el-row>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogDetailVisible = false">取 消</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :visible.sync="dialogPreviewVisible">
		  <img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';

	export default {
		extends: BaseSearch,
		props: ['device'],
		data() {
			return {
				loginUserId:'',
				url: 'maintenance/order',
				name: '维护工单',
				teamList: [],
				roleId:null,
				queryDeviceParams: {
					currentPage: 1,
					pageSize: 10,
					defaultSort: {
						order: 'desc',
						prop: 'id'
					}
				},
				dialogDeviceVisible: false,
				deviceList: [],
				deviceLoading: false,
				dialogDetailVisible:false,
				label_style: {
					'width': "100px", 
					'float': 'right',
					'text-align': 'right',
					'display': 'block',
					'word-break': 'break-all'
				},
				userList: [],
				rules: {
					title: [{
							required: true,
							message: '请输入工单标题',
							trigger: 'blur'
						},
						{
							max: 200,
							message: '长度最长支持200',
							trigger: 'blur'
						}
					],
					type: [{
						required: true,
						message: '请选择维护类型',
						trigger: 'blur'
					}],
					deviceId: [{
						required: true,
						message: '请选择关联设备',
						trigger: 'blur'
					}],
					description: [{
							required: true,
							message: '请输入描述',
							trigger: 'blur'
						},
						{
							max: 500,
							message: '长度最长支持100',
							trigger: 'blur'
						}
					],
					level: [{
						required: true,
						message: '请选择优先级',
						trigger: 'blur'
					}],
					operatorId: [{
						required: true,
						message: '请选择分配人员',
						trigger: 'blur'
					}]
				},
				imageList: [],
				dialogImageUrl:"",
				dialogPreviewVisible:false
			};
		},
		filters: {
			formatLevel(level) {
				if (level == 1) {
					return "低"
				} else if (level == 2) {
					return "中"
				} else if (level == 3) {
					return "高"
				}
			},
			formatStatus(status) {
				if (status == 0) {
					return "未处理"
				} else if (status == 1) {
					return "已处理"
				}
			},
			formatType(type) {

			}

		},
		methods: {
			handleDetail(row) {
				this.createUpdateForm(row);
				this.dialogDetailVisible = true;
			},
			handleClose(done){
				this.imageList=[]
				if(done){
					done();
				}else{
					this.dialogVisible = false
				}
			},
			handleUploadSuccess(res, file) {
				this.imageList.push(file);
				this.addOrUpdateForm.imageList.push(res.data);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogPreviewVisible = true;
			},
			beforeEdit() {
				if (!this.addOrUpdateForm.imageList) {
					this.addOrUpdateForm.imageList = []
				}
				this.deviceList=[{
					id:this.addOrUpdateForm.deviceId,
					title:this.addOrUpdateForm.deviceTitle
				}]
				
				this.imageList = []
				this.addOrUpdateForm.imageList.forEach((item, index) => {
					this.imageList.push({
						url: item,
						uid: index
					})
				});
			},
			handleRemove(file) {
				var index = this.imageList.findIndex(item => item.uid === file.uid)
				this.imageList.splice(index, 1);
			},
			beforeUpdate() {
				this.addOrUpdateForm.deviceTitle = this.$refs.deviceSelect.selected.label
				this.addOrUpdateForm.operatorName = this.$refs.operatorSelect.selected.label
				this.addOrUpdateForm.type = "default"
			},
			queryTeamList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'team/query',
					data: {
						currentPage: 1,
						pageSize: 100,
						defaultSort: {
							order: 'desc',
							prop: 'id'
						}
					},
				}).then(function(res) {
					that.teamList = res.data.data;
				})
			},
			queryUserList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'user/query',
					data: {
						currentPage: 1,
						pageSize: 100,
						defaultSort: {
							order: 'desc',
							prop: 'id'
						}
					},
				}).then(function(res) {
					that.userList = res.data.data;
				})
			},
			queryDeviceList(query) {
				let that = this;
				this.deviceLoading = true;
				this.queryDeviceParams.title = query;
				this.$http({
					method: 'POST',
					url: 'devices/query',
					data: this.queryDeviceParams,
				}).then(function(res) {
					that.deviceList = res.data.data;
					that.deviceLoading = false
				})
			},
			deviceSelectFocus() {
				this.queryDeviceList()
			},
		},
		mounted: function() {
			this.loginUserId= sessionStorage.getItem('_userId');
			if (this.device) {
				this.queryParams.deviceId = this.device.id
			}
			this.roleId = sessionStorage.getItem('_roleId');
			if(this.roleId==2){
				this.queryTeamList()
			}
			if (this.$route.query.teamId) {
				this.queryParams.teamId=this.$route.query.teamId;
			}
			this.queryUserList()
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}

	/deep/ .el-upload-list--picture-card .el-upload-list__item {
		width: 80px;
		height: 80px;
	}

	/deep/ .el-upload--picture-card {
		width: 80px;
		height: 80px;
		line-height: 90px;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/order/maintenanceOrder.vue